import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevrons-up",
  "use": "chevrons-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevrons-up\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m10 5-5-5-5 5\" transform=\"translate(7 6)\" /><path d=\"m10 5-5-5-5 5\" transform=\"translate(7 13)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol